var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticClass:"area"},_vm._l((_vm.cells),function(row,r){return _c('tr',{key:r},_vm._l((row),function(cell,c){return _c('td',{key:c,class:cell})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }